import {Injectable} from '@angular/core';
import {Loader} from '@googlemaps/js-api-loader';

@Injectable({
    providedIn: 'root'
})
export class GoogleLoaderService {
    private loader: Loader = new Loader({
        apiKey: "AIzaSyDTOlh36rmI508E-5UqTd4_wuaXqQRNyCQ",
        version: "weekly",
        libraries: ["places"],
        nonce: (document.querySelector('meta[name="CSP_NONCE"]') as HTMLMetaElement)?.content
    });
    private loadPromise?: Promise<typeof google>;

    loadGoogleMaps(): Promise<typeof google> {
        if (!this.loadPromise) {
            this.loadPromise = this.loader.load();
        }
        return this.loadPromise;
    }
}
